import React from 'react';

import Duration from 'components/Duration';

import { getCallDirectionIcon } from 'views/Home/Dialler/utils';

import type { CallDirection } from 'store/call/call.state';

import styles from 'views/Home/Dialler/Monitoring/monitoring.module.scss';

export type Props = {
    name?: string;
    callDirection?: CallDirection;
    start?: Date;
};

type CallDirectionMapping = {
    [key in CallDirection]: string;
};

const callDirectionMapping: CallDirectionMapping = {
    inbound: 'Inbound call',
    outbound: 'Outbound call',
    transfer: 'Transfer call',
    queue_transfer: 'Queue transfer call',
    callback: 'Callback call',
    api: 'API call',
    disconnect: 'Disconnect call',
    monitoring: 'Monitoring call',
    external_outbound: 'External outbound call',
    unknown: 'Unknown call',
};

const Monitoring: React.FC<Props> = ({ name = 'Unknown', callDirection = 'unknown', start }) => {
    const directionText = callDirection && callDirectionMapping[callDirection];

    const callDirectionIcon = getCallDirectionIcon(callDirection);

    return (
        <div className={styles.container}>
            <div className={styles.details}>
                <img src={callDirectionIcon} alt="" />
                <h4 id="monitoring-dialler">
                    {directionText}: {name}
                </h4>
            </div>
            <Duration date={start} />
        </div>
    );
};

export default Monitoring;
